export default __webpack_public_path__ + "static/media/11_photo.674d24c5.jpeg";